const haveChildren = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  {
    label: "Yes, but doesn't stay with me",
    value: "Yes, but doesn't stay with me",
  },
];
export default haveChildren;
